<template>
  <div class="individual-analysis">
    <template v-if="showSamples">
      <sample-view
        :sample-id="currentSampleId"
        :asset-module-id="assetModuleId"
        :key="currentSampleId"
      />
      <samples-paginator
        v-if="!isSingleSampleView"
        v-model="currentSampleId"
        :samples="paginator"
      />
    </template>
    <s-empty-list
      v-else
      :loading="loading"
    />
  </div>
</template>

<script>
import LoadingMixin from '@/services/loadingMixin';
import Service from '@/domain/services/installation/engineering/physicalChemical/generalTab';
import { compareFor } from '@/services/sortHelper';
import SamplesPaginator from '@/domain/components/installation/engineering/chromatography/methodsAndDiagnostics/individualAnalysis/SamplesPaginator';
import SampleView from './SampleView';

export default {
  name: 'PhysicalChemicalReport',
  props: {
    sampleIds: Array,
    assetModuleId: String,
  },
  components: {
    SampleView,
    SamplesPaginator,
  },
  mixins: [
    LoadingMixin,
  ],
  data: () => ({
    samples: null,
    currentSampleId: null,
  }),
  computed: {
    paginator() {
      const pages = this.sampleIds.map(it => this.samples.find(element => element.id === it));
      return pages.sort((a, b) => a.number - b.number);
    },
    showSamples() {
      return !this.loading && this.hasSamples;
    },
    hasSamples() {
      return this.samples && this.samples.length > 0;
    },
    isSingleSampleView() {
      return this.sampleIds.length === 1;
    },
    currentSampleHandler() {
      return (this.sampleIds && Array.isArray(this.sampleIds))
        ? this.paginator[0].id : this.sampleIds;
    },
  },
  created() {
    this.loadSampleData();
  },
  methods: {
    loadSampleData() {
      this.startLoading();
      Service.getSamplesIdLookup(this.assetModuleId, this.sampleIds)
        .then((data) => {
          this.samples = data;
          this.samples.sort(compareFor('number'));
          this.currentSampleId = this.currentSampleHandler;
        })
        .finally(() => {
          this.endLoading();
        });
    },
  },
};
</script>
<style lang="sass" scoped>
.individual-analysis
  display: flex
  flex-direction: column
  width: 100%
</style>
